import { BrowserRouter as Router, Route } from "react-router-dom";
import ProspectReg from "./prospect_reg";
import MyAccountReg from "./myaccount_reg";
import RetailReg from "./retail_reg";
import BackOfficeReg from "./backoffice_reg";
import FundboardReg from "./fundboard_reg";
import EntityOwnedReg from "./entityOwned_reg";
import Registration from "./registration";
import MyTeamsAssistantReg from "./MyTeamsAssistantReg";
import PolicyOwnerEnroll from "./policyowner_enroll";
import FPEnroll from "./fp_enroll";
import DelegateEnroll from "fpdelegate_enroll";

import PotentialInsuredEnroll from "./potential_insured";
import {
    TPIA,
    INTERNAL,
    RIA_FIRM,
    WHOLESALER,
    ANNUITIES_FP_PATH,
    RIA_PATH,
    MYACCOUNT_PATH,
    BACKOFFICE_PATH,
    FUNDBOARD_PATH,
    ENTITY_OWNED_PATH,
    TPIA_PATH,
    INTERNAL_PATH,
    WHOLESALER_PATH,
    RIA_FIRM_PATH,
    MY_TEAMS_ASSISTANT_PATH,
    POLICYOWNER_ENROLL_URL,
    FP_ENROLL_URL,
    FP_FINDUSER_URL_CONTRACTED,
    POTENTIAL_INSURED_URL,
    SSA_PATH,
    INVITEDUSER_ENROLL_URL,
    DELEGATE_ENROLL_URL,
    FP_FINDUSER_URL_NONCONTRACTED,
    UPDATE_USER_URL_CONTRACTED,
    UPDATE_USER_URL_NONCONTRACTED,
    FPINVITEE_ENROLL_URL
} from "./constants";
import "./styles/App.scss";
import SSARegistration from "./ssa_reg";
import InvitedUserEnroll from "./invited_user";
import FPFindUserContracted from "fp_findUser_Contracted";
import FPFindUserNonContracted from "fp_findUser_NonContracted";
import UpdateUserContracted from "fp_updateUser_Contracted";
import UpdateUserNonContracted from "fp_updateUser_NonContracted";
import NoncontractedInviteeEnroll from "fpnoncontracted_enroll";

function App() {
    return (
        <div className="App">
            <Router basename={process.env.PUBLIC_URL}>
                <Route exact path={ANNUITIES_FP_PATH} component={RetailReg} />
                <Route exact path={RIA_PATH} component={ProspectReg} />
                <Route exact path={MYACCOUNT_PATH} component={MyAccountReg} />
                <Route
                    exact
                    path={POLICYOWNER_ENROLL_URL}
                    component={PolicyOwnerEnroll}
                />
                <Route
                    exact
                    path={DELEGATE_ENROLL_URL}
                    component={DelegateEnroll}
                />
                <Route
                    exact
                    path={POTENTIAL_INSURED_URL}
                    component={PotentialInsuredEnroll}
                />

                <Route
                    exact
                    path={INVITEDUSER_ENROLL_URL}
                    component={InvitedUserEnroll}
                />
                <Route
                    exact
                    path={ENTITY_OWNED_PATH}
                    component={EntityOwnedReg}
                />
                <Route exact path={FP_ENROLL_URL} component={FPEnroll} />
                <Route
                    exact
                    path={FPINVITEE_ENROLL_URL}
                    component={NoncontractedInviteeEnroll}
                />
                <Route
                    exact
                    path={FP_FINDUSER_URL_CONTRACTED}
                    component={FPFindUserContracted}
                />
                <Route
                    exact
                    path={FP_FINDUSER_URL_NONCONTRACTED}
                    component={FPFindUserNonContracted}
                />
                <Route
                    exact
                    path={UPDATE_USER_URL_CONTRACTED}
                    component={UpdateUserContracted}
                />
                <Route
                    exact
                    path={UPDATE_USER_URL_NONCONTRACTED}
                    component={UpdateUserNonContracted}
                />
                <Route exact path={FUNDBOARD_PATH} component={FundboardReg} />
                <Route exact path={BACKOFFICE_PATH} component={BackOfficeReg} />
                <Route
                    exact
                    path={MY_TEAMS_ASSISTANT_PATH}
                    component={MyTeamsAssistantReg}
                />
                <Route exact path={TPIA_PATH}>
                    <Registration userRole={TPIA} />
                </Route>
                <Route exact path={INTERNAL_PATH}>
                    <Registration userRole={INTERNAL} />
                </Route>
                <Route exact path={WHOLESALER_PATH}>
                    <Registration userRole={WHOLESALER} />
                </Route>
                <Route exact path={RIA_FIRM_PATH}>
                    <Registration userRole={RIA_FIRM} />
                </Route>
                <Route exact path={SSA_PATH} component={SSARegistration} />
            </Router>
        </div>
    );
}
export default App;
